<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div class="ls-board-box">
      <div class="row ls-box-group">
        <div class="col-sm-3 col-lg-3">
          <div class="ls-box">
            <div class="ls-box-head">
              <h6 class="ls-title-4">{{ $t('taxes.attributes.id') }}</h6>
            </div>
            <div data-test="tax.id" class="ls-box-body">
              <strong>{{ tax.id }}</strong>
            </div>
            <div class="ls-box-footer"><small><div data-test="tax.created" v-html="$t('taxes.show.since', { date: date.parseDate(tax.created_at) })"></div></small></div>
          </div>
        </div>

        <div class="col-sm-3 col-lg-3">
          <div class="ls-box">
            <div class="ls-box-head">
              <h6 class="ls-title-4">{{ $t('taxes.show.tax_status') }}</h6>
            </div>
            <div data-test="tax.status" class="ls-box-body">
              <strong v-if="tax.active">{{ $t('taxes.attributes.active') }}</strong>
              <strong v-else>{{ $t('taxes.attributes.inactive') }}</strong>
            </div>
            <div class="ls-box-footer">
              <authorized-link tag="update_tax" v-if="tax.active">
                <button class="ls-btn" :class="{ 'ls-btn-danger': tax.active }" @click="inactivateTax()" v-model="tax.active">{{ $t('application.button.inactive') }}</button>
              </authorized-link>
              <authorized-link tag="update_tax" v-else>
                <button class="ls-btn" :class="{ 'ls-btn-primary': tax.active }" @click="activateTax()" v-model="tax.active">{{ $t('application.button.active') }}</button>
              </authorized-link>
            </div>
          </div>
        </div>

        <div class="col-sm-3 col-lg-3">
          <div class="ls-box">
            <div class="ls-box-head">
              <h6 class="ls-title-4">{{ $t('taxes.show.active_in_contract') }}</h6>
            </div>
            <div class="ls-box-body">
              <strong>{{ tax.quantity_contracts_applied }}</strong>
            </div>
            <div class="ls-box-footer"></div>
          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="ls-box">
          <div class="ls-float-left">
            <h4 class="ls-title-4">{{ $t('taxes.show.details') }}</h4>
          </div>
          <div class="ls-float-right">
            <authorized-link tag="update_tax" v-if="tax.active">
              <router-link :to="{ name: 'edit_tax', params: { id: tax.id }}" class="ls-btn-primary ls-no-margin">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                <span class="ls-sm-margin-rigth">{{ $t('application.button.edit') }}</span>
              </router-link>
            </authorized-link>
          </div>
          <div class="ls-clearfix"></div>

          <div class="row">
            <label class="ls-label col-md-6 col-lg-8">
              <b class="ls-label-text">{{ $t('taxes.show.tax_name') }}</b>
              <p name="tax.name">{{ tax.name }}</p>
            </label>
            <label class="ls-label col-md-6 col-lg-8">
              <b class="ls-label-text">{{ $t('taxes.show.tax_value') }}</b>
              <p name="tax.value">{{ tax.value }}%</p>
            </label>
            <label class="ls-label col-md-6 col-lg-8">
              <b class="ls-label-text">{{ $t('taxes.show.tax_scope') }}</b>
              <p  name="tax.scope">{{ tax.scope }}</p>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 ls-display-flex justify-content-flex-end ls-no-padding">
      <router-link class="ls-btn" :to="{ name: 'taxes' }" :title="$t('application.menu.taxes')" role="menuitem">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        <span>{{ $t('application.button.back') }}</span>
      </router-link>
    </div>
    <modal-inactive v-model="inactiveObjects"></modal-inactive>
    <modal-activate v-model="activateObjects"></modal-activate>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import ModalInactive from './components/ModalInactive'
  import ModalActivate from './components/ModalActivate'
  import scroll from 'src/utils/scroll'
  import date from 'src/utils/date'

  export default {
    name: 'ShowTax',
    components: { ModalInactive, ModalActivate, Breadcrumb },
    data () {
      return {
        inactiveObjects: { show: false },
        activateObjects: { show: false },
        date: date,
        error: false,
        crumbs: {
          'ico': 'ls-ico-docs',
          'section': this.$t('taxes.show.view_tax'),
          'paths': {
            0: {
              'title': this.$t('taxes.main.title'),
              'path': '/taxes'
            },
            1: {
              'title': this.$t('taxes.show.details'),
              'path': ''
            }
          }
        }
      }
    },
    mounted () {
      this.getTax()
    },
    computed: {
      ...mapGetters(['tax'])
    },
    methods: {
      ...mapActions(['loadTax']),
      getTax () {
        this.$loader.show()
        this.loadTax(this.$route.params.id).then(this.afterLoad)
      },
      afterLoad () {
        this.$loader.hide()
      },
      inactivateTax () {
        this.inactiveObjects.show = true
        this.inactiveObjects.callback = scroll.scrollToFlash
      },
      activateTax () {
        this.activateObjects.show = true
        this.activateObjects.callback = scroll.scrollToFlash
      }
    }
  }
</script>
<style type="text/css">
  .justify-content-flex-end {
    justify-content: flex-end;
  }
</style>



// WEBPACK FOOTER //
// Show.vue?045de073